/**
 * @license
 * Copyright (c) %FIRST_YEAR% %CURRENT_YEAR%, Oracle and/or its affiliates. All rights reserved.
 * https://www.oracle.com/contracts/docs/cloud_csa_online_v062223_us_eng.pdf?download=false&er=221886
 * @ignore
 */
// DO NOT MODIFY THIS FILE MANUALLY!
// This file is automatically generated based on the corresponding SVG image in
// the packages/oraclejet-preact/resources/icons folder.
import { ComponentProps } from 'preact';
import { Icon } from '../../UNSAFE_Icon';
type Props = Omit<ComponentProps<typeof Icon>, 'viewBox' | 'children'>;
const SvgNetworkFlowDiagram = (props: Props) => (
  <Icon viewBox="0 0 24 24" {...props}>
    <g fill="none">
      <path
        d="M5 4a1 1 0 1 0 0 2 1 1 0 0 0 0-2zM2 5a3 3 0 0 1 5.855-.925c1.253.22 2.41.9 3.29 1.78.314.315.603.665.855 1.042.252-.377.54-.727.855-1.042.88-.88 2.037-1.56 3.29-1.78A3.001 3.001 0 0 1 22 5a3 3 0 0 1-5.789 1.108c-.683.182-1.367.587-1.941 1.162-.575.574-.98 1.258-1.162 1.941a3.001 3.001 0 0 1 0 5.578c.182.683.587 1.367 1.162 1.941.574.575 1.258.98 1.941 1.162a3.001 3.001 0 1 1-.066 2.033c-1.252-.22-2.41-.9-3.29-1.78A6.874 6.874 0 0 1 12 17.103c-.252.377-.54.727-.855 1.042-.88.88-2.037 1.56-3.29 1.78A3.001 3.001 0 0 1 2 19a3 3 0 0 1 5.789-1.108c.683-.182 1.367-.587 1.941-1.162.575-.574.98-1.258 1.162-1.941A3.01 3.01 0 0 1 9.171 13H7.829a3.001 3.001 0 1 1 0-2h1.342a3.01 3.01 0 0 1 1.721-1.789c-.182-.683-.587-1.367-1.162-1.941-.574-.575-1.258-.98-1.941-1.162A3.001 3.001 0 0 1 2 5zm3 13a1 1 0 1 0 0 2 1 1 0 0 0 0-2zm6-6a1 1 0 1 0 2 0 1 1 0 0 0-2 0zm-6-1a1 1 0 1 0 0 2 1 1 0 0 0 0-2zm14-7a1 1 0 1 0 0 2 1 1 0 0 0 0-2zm-1 15a1 1 0 1 0 2 0 1 1 0 0 0-2 0z"
        fill="currentcolor"
      />
    </g>
  </Icon>
);
export { SvgNetworkFlowDiagram as NetworkFlowDiagram };
